import { SVGProps, Ref, forwardRef } from 'react';

export const BoxFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M23 15c0 3.771 0 5.657-1.172 6.828S18.771 23 15 23H9c-3.771 0-5.657 0-6.828-1.172S1 18.771 1 15V9.9h22z"
            fill="currentColor"
        />
        <path
            d="M15.292 1c1.804 0 2.706 0 3.43.448.726.448 1.13 1.255 1.936 2.868L22.55 8.1H12.9V1z"
            fill="currentColor"
        />
        <path
            d="M11.1 8.1H1.45l1.892-3.784c.807-1.613 1.21-2.42 1.935-2.868S6.904 1 8.708 1H11.1z"
            fill="currentColor"
        />
    </svg>
));
BoxFilledSize24Glyph.displayName = 'BoxFilledSize24Glyph';
